import { resetBankAndAddress } from '../actions/postalCodeAction';
import {
	AUTH_SUBSCRIBE,
	AUTH_SUBSCRIBE_ERROR,
	SUBMIT_AUTH_SUBSCRIBE,
	AUTH_TOKEN_KEY,
	AUTH_USER_KEY,
	AUTH_PROFILE_UPDATE,
	AUTH_COUNTRY_UPDATE,

	EMAIL_VERIFICATION,
	EMAIL_VERIFICATION_SUBMIT,
	EMAIL_VERIFICATION_ERROR,
	EMAIL_VERIFICATION_LINK_SENT,

	AUTH_PROFILE_FETCH,
	AUTH_SIGN_OUT,
	AUTH_SIGN_IN_POST,
	AUTH_SIGN_UP_POST,
	AUTH_REFRESH_TOKEN_FETCH,
	AUTH_SOCIAL_SIGN_IN,

	PROMISE_PENDING,
	PROMISE_REJECTED,
	PROMISE_FULFILLED,

	BECOME_SELLER,
	RESET_TOKEN_TOBE_SELLER,
	COURIER_PRICE_KEY,
	AUTH_CURRENCY_RATE_FETCH
} from '../constants/';

import { SET_USER_RAFFLE_TICKET } from "../constants/kafairConstants"

import { jwtPayloads, jwtDecode } from '../utils/';
import error from '../utils/error';

const initialState = {
	refreshTkn: {
		isSubmit: false,
		error: null
	},
	signIn: {
		isSubmit: false,
		error: null
	},
	signUp: {
		isSubmit: false,
		error: null
	},
	updateProfile: {
		isSubmit: false,
		error: null
	},
	updateCountry: {
		isSubmit: false,
		error: null
	},
	userdata: {
		isFetch: false,
		error: null,
		roles: [],
		balance: 0,
		current_balance: 0,
		locked_balance: 0,
		current_locked_balance: 0,
		balance_with_fee: 0,
		current_balance_with_fee: 0
	},
	userCurrency: {
		ratio: 1,
		currency: "IDR"
	},
	userVerification: { isSubmit: false },
	userSentLinkEmailVerify: { isSubmit: false },
	subscribe: {
		isSubmit: false,
		error: null
	},
	isLogged: localStorage.getItem(AUTH_TOKEN_KEY) !== null ? true : false,
	shouldRedirect: false,
	otpCode: {
		success: false,
		error: null,
		isSubmit: false,
		isReset: false
	},
	otpStatus: {
		success: false,
		error: null,
		isSubmit: false,
		data: {}
	},
}

export const login = ({ token }) => {
	localStorage.setItem(AUTH_TOKEN_KEY, token);
	const userJwtPayload = jwtPayloads(token);
	localStorage.setItem(AUTH_USER_KEY, userJwtPayload);
	localStorage.removeItem(COURIER_PRICE_KEY);
	return getRoles(userJwtPayload);
}

const logout = () => {
	localStorage.removeItem(AUTH_TOKEN_KEY);
	localStorage.removeItem(AUTH_USER_KEY);
	return {
		...initialState,
		isLogged: false
	}
}

const getRoles = (userJwtPayload) => {
	if (userJwtPayload) {
		const { roles } = JSON.parse(jwtDecode(userJwtPayload));
		return roles ? roles.split(',') : [];
	}
	return [];
}

const applyAuthProfile = (lastState, { payload }) => {
	const { data, status_code, message } = payload;
	// const roles = getRoles(localStorage.getItem(AUTH_USER_KEY));
	const roles = data.roles.map(element => element.name);
	return { ...lastState, userdata: { ...lastState.userdata, isFetch: false, error: null, ...data, status_code, message, roles } }
}

const errorSubscribe = (state, payload) => {
	const data = (payload.response !== null && payload.response !== undefined) ? { ...payload.response.data } : { error: { message: 'I got something undefined errors', status_code: 500 } };
	return { ...state, subscribe: { ...state.subscribe, error: { ...data.error }, data: null } };
}

const applySubscribe = (state, payload) => {
	const { data, status_code, message } = payload;
	return { ...state, subscribe: { ...state.subscribe, data: { ...data, message, status_code }, error: null } };
}

const applySignUp = (lastState, { payload }) => {
	const { data, status_code, message } = payload;
	const roles = login(data);
	return { ...lastState, userdata: { ...lastState.userdata, roles }, signUp: { isSubmit: false, error: null, status_code, message }, isLogged: true, shouldRedirect: true }
}


const applySignIn = (lastState, { payload }) => {
	const { data, status_code, message } = payload;
	const roles = login(data);
	return { ...lastState, userdata: { ...lastState.userdata, roles }, signIn: { isSubmit: false, error: null, status_code, message }, isLogged: true, shouldRedirect: true }
}

const applyRefreshTkn = (lastState, { payload }) => {
	const { data, status_code, message } = payload;
	const roles = login(data);
	return { ...lastState, userdata: { ...lastState.userdata, roles }, refreshTkn: { isSubmit: false, error: null, status_code, message }, isLogged: true, shouldRedirect: true }
}

const applySentLinkEmailVerify = (lastState, { payload }) => {
	const { data, status_code, message } = payload;
	return { ...lastState, userSentLinkEmailVerify: { isSubmit: false, error: null, status_code, message } }
}

// const applyLogin = payload =>
// 	payload.error === null || payload.error?initialState
// 		:{...payload}

const applySignSocial = (state, { data, status_code, message }) => {
	const roles = login(data);
	let newState = {
		...state,
		userdata: {
			...state.userdata,
			roles
		},
		signIn: {
			...initialState.signIn,
			status_code,
			message
		},
		signUp: {
			...initialState.signUp,
			status_code,
			message,
		},
		isLogged: true,
		shouldRedirect: true
	}
	return newState
}

const applyUpdateProfile = (lastState, { payload }) => {
	const { data, status_code, message } = payload;
	// const { roles } = login(data);
	return { ...lastState, userdata: { ...lastState.userdata, ...data.user, status_code }, updateProfile: { isSubmit: false, error: null, status_code, message } }
	// return lastState;
}

const updateProfileError = (lastState, { payload }) => {
	const { status_code, message } = payload.response.data.error;
	return { ...lastState, updateProfile: { isSubmit: false, ...error(payload.response.data.error), status_code, message } }
}

const applyUpdateCountry = (lastState, { payload }) => {
	const { data, status_code, message } = payload;
	// const { roles } = login(data);
	return { ...lastState, userdata: { ...lastState.userdata, ...data.user, status_code }, updateCountry: { isSubmit: false, error: null, status_code, message } }
	// return lastState;
}

const updateCountryError = (lastState, { payload }) => {
	const { status_code, message } = payload.response.data.error;
	return { ...lastState, updateCountry: { isSubmit: false, ...error(payload.response.data.error), status_code, message } }
}

const catchVerificationError = (state, payload) => {

	return {
		...state, userVerification: {
			...state.userVerification,
			error: payload.response === undefined ? { message: 'Undefined Error', status_code: 500 } : { ...payload.response.data.error }
		}
	}
}
const authReducer = (state = initialState, action) =>
	action.type === SUBMIT_AUTH_SUBSCRIBE ? { ...state, subscribe: { ...state.subscribe, isSubmit: action.payload } } :
		action.type === AUTH_SUBSCRIBE_ERROR ? errorSubscribe(state, action.payload) :
			action.type === AUTH_SUBSCRIBE ? applySubscribe(state, action.payload) :

				action.type === AUTH_SIGN_OUT ? logout() :
					action.type === `${AUTH_SIGN_IN_POST}${PROMISE_PENDING}` ? { ...state, signIn: { ...state.signIn, isSubmit: true } } :
						action.type === `${AUTH_SIGN_IN_POST}${PROMISE_FULFILLED}` ? applySignIn(state, action) :
							action.type === `${AUTH_SIGN_IN_POST}${PROMISE_REJECTED}` ? { ...state, signIn: { isSubmit: false, ...error(action.payload) } } :

								action.type === `${AUTH_REFRESH_TOKEN_FETCH}${PROMISE_PENDING}` ? { ...state, refreshTkn: { ...state.refreshTkn, isSubmit: true } } :
									action.type === `${AUTH_REFRESH_TOKEN_FETCH}${PROMISE_FULFILLED}` ? applyRefreshTkn(state, action) :
										action.type === `${AUTH_REFRESH_TOKEN_FETCH}${PROMISE_REJECTED}` ? { ...state, refreshTkn: { isSubmit: false, ...error(action.payload) } } :

											action.type === `${AUTH_SIGN_UP_POST}${PROMISE_PENDING}` ? { ...state, signUp: { ...state.signUp, isSubmit: true } } :
												action.type === `${AUTH_SIGN_UP_POST}${PROMISE_FULFILLED}` ? applySignUp(state, action) :
													action.type === `${AUTH_SIGN_UP_POST}${PROMISE_REJECTED}` ? { ...state, signUp: { isSubmit: false, ...error(action.payload) } } :

														action.type === `${AUTH_PROFILE_FETCH}${PROMISE_PENDING}` ? { ...state, userdata: { ...state.userdata, isFetch: true } } :
															action.type === `${AUTH_PROFILE_FETCH}${PROMISE_FULFILLED}` ? applyAuthProfile(state, action) :
																action.type === `${AUTH_PROFILE_FETCH}${PROMISE_REJECTED}` ? { ...state, userdata: { isFetch: false, roles: [], ...error(action.payload) } } :

																	action.type === `${AUTH_CURRENCY_RATE_FETCH}${PROMISE_PENDING}` ? { ...state, userCurrency: { ...state.currency, isFetch: true } } :
																		action.type === `${AUTH_CURRENCY_RATE_FETCH}${PROMISE_FULFILLED}` ? { ...state, userCurrency: { ...state.currency, ratio: action.payload.data.ratio, currency: action.payload.data.currency, isFetch: false } } :
																			action.type === `${AUTH_CURRENCY_RATE_FETCH}${PROMISE_REJECTED}` ? { ...state, userCurrency: { isFetch: false, ...error(action.payload) } } :

																				action.type === `${EMAIL_VERIFICATION_LINK_SENT}${PROMISE_PENDING}` ? { ...state, userSentLinkEmailVerify: { ...state.userSentLinkEmailVerify, isSubmit: true } } :
																					action.type === `${EMAIL_VERIFICATION_LINK_SENT}${PROMISE_FULFILLED}` ? applySentLinkEmailVerify(state, action) :
																						action.type === `${EMAIL_VERIFICATION_LINK_SENT}${PROMISE_REJECTED}` ? { ...state, userSentLinkEmailVerify: { isSubmit: false, ...error(action.payload) } } :

																							action.type === EMAIL_VERIFICATION_ERROR ? catchVerificationError(state, action.payload) :
																								action.type === EMAIL_VERIFICATION_SUBMIT ? { ...state, userVerification: { ...state.userVerification, isSubmit: action.payload } } :
																									action.type === EMAIL_VERIFICATION ? { ...state, userVerification: { ...state.userVerification, ...action.payload } } :

																										action.type === `${AUTH_SOCIAL_SIGN_IN}${PROMISE_PENDING}` ? { ...state, signIn: { ...state.signIn, isSubmit: true }, signUp: { ...state.signUp, isSubmit: true } } :
																											action.type === `${AUTH_SOCIAL_SIGN_IN}${PROMISE_FULFILLED}` ? applySignSocial(state, action.payload) :
																												action.type === `${AUTH_SOCIAL_SIGN_IN}${PROMISE_REJECTED}` ? { ...state, signIn: { isSubmit: false, ...error(action.payload) } } :
																													action.type === `${BECOME_SELLER}` ? { ...state, userdata: { ...state.userdata, roles: getRoles(localStorage.getItem(AUTH_USER_KEY)) } } :

																														action.type === `${AUTH_PROFILE_UPDATE}${PROMISE_PENDING}` ? { ...state, updateProfile: { ...state.updateProfile, isSubmit: true } } :
																															action.type === `${AUTH_PROFILE_UPDATE}${PROMISE_FULFILLED}` ? applyUpdateProfile(state, action) :
																																// action.type === `${AUTH_PROFILE_UPDATE}${PROMISE_REJECTED}` ? {...state,updateProfile:{isSubmit:false, ...error(action.payload)}}:
																																action.type === `${AUTH_PROFILE_UPDATE}${PROMISE_REJECTED}` ? updateProfileError(state, action) :

																																	action.type === `${AUTH_COUNTRY_UPDATE}${PROMISE_PENDING}` ? { ...state, updateCountry: { ...state.updateCountry, isSubmit: true } } :
																																		action.type === `${AUTH_COUNTRY_UPDATE}${PROMISE_FULFILLED}` ? applyUpdateCountry(state, action) :
																																			action.type === `${AUTH_COUNTRY_UPDATE}${PROMISE_REJECTED}` ? updateCountryError(state, action) :

																																				action.type === `TOGGLE_HOLIDAY_MODE${PROMISE_PENDING}` ? { ...state, userdata: { ...state.userdata, isFetch: true } } :
																																					action.type === `TOGGLE_HOLIDAY_MODE${PROMISE_FULFILLED}` ? applyAuthProfile(state, action) :

																																						action.type === `${SET_USER_RAFFLE_TICKET}${PROMISE_FULFILLED}` ? { ...state, userdata: { ...state.userdata, golden_ticket: action.payload.data.golden.total, standard_ticket: action.payload.data.standard.total, isFetch: false } } :
																																							action.type === `${SET_USER_RAFFLE_TICKET}${PROMISE_REJECTED}` ? { ...state, userdata: { ...state.userdata, isFetch: false, ...error(action.payload) } } :

																																								action.type === `${"GET_OTP_CODE"}${PROMISE_PENDING}` ? { ...state, otpCode: { ...state.otpCode, isSubmit: true } } :
																																									action.type === `${"GET_OTP_CODE"}${PROMISE_FULFILLED}` ? { ...state, otpCode: { ...state.otpCode, success: true, isSubmit: false, error: null, isReset: true } } :
																																										action.type === `${"GET_OTP_CODE"}${PROMISE_REJECTED}` ? { ...state, otpCode: { ...state.otpCode, success: false, isSubmit: false, ...error(action.payload), isReset: true } } :
																																											action.type?.includes("GET_OTP_CODE_RESET") ? { ...state, otpCode: { success: false, error: null, isSubmit: false, isReset: false, message: null, status_code: null } } :

																																												action.type === `${"GET_OTP_STATUS"}${PROMISE_PENDING}` ? { ...state, otpStatus: { ...state.otpStatus, isSubmit: true } } :
																																													action.type === `${"GET_OTP_STATUS"}${PROMISE_FULFILLED}` ? { ...state, otpStatus: { ...state.otpStatus, success: true, isSubmit: false, error: null, data: action.payload } } :
																																														action.type === `${"GET_OTP_STATUS"}${PROMISE_REJECTED}` ? { ...state, otpStatus: { ...state.otpStatus, success: false, isSubmit: false, ...error(action.payload), data: {} } } :
																																															state

export default authReducer